enum ExportMapActions {
  START_JOB = '[export map] Start job',
  SET_DPI = '[export map] Set dpi',
  SET_ELEMENT_PROPS = '[export map] SET_ELEMENT_PROPS',
  SET_LANDSCAPE = '[export map] Set landscape',
  SET_PAGE_SIZE = '[export map] Set page size',
  SET_LAYOUT_WH = '[export map] Set layout wh',
  SET_MARGINS = '[export map] SET_MARGINS',
  SET_PIXEL_TO_UNIT_FACTOR = '[export map] Set pixels to units factor',
  SET_PREVIEW_MODE = '[export map] SET_PREVIEW_MODE',
  SET_PIXEL_TO_MM_FACTOR = '[export map] SET_PIXEL_TO_MM_FACTOR',
  SET_NON_MARGIN_PAPER_WH_MM = '[export map] SET_NON_MARGIN_PAPER_WH_MM',
  SET_MAP_PROPS = '[export map] SET_MAP_PROPS',
  SET_ZOOM_FACTOR = '[export map] SET_ZOOM_FACTOR',
  SET_FEATURES = '[export map] SET_FEATURES',
  SET_LAYOUTS = '[export map] SET_LAYOUTS',
  SET_USE_BACKGROUND = '[export map] SET_USE_BACKGROUND',
  SET_EDIT_MODE = '[export map] SET_EDIT_MODE'
}
export default ExportMapActions
